import { render, staticRenderFns } from "./ConstructionSubFolderManager.vue?vue&type=template&id=5daf233f&scoped=true&lang=pug&"
import script from "./ConstructionSubFolderManager.vue?vue&type=script&lang=ts&"
export * from "./ConstructionSubFolderManager.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionSubFolderManager.vue?vue&type=style&index=0&id=5daf233f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf233f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTooltip})
